/** Same GTM container as the marketing site. GA4 is configured inside that container. */
export const GTM_ID = 'GTM-WKTC46WN';

export type AnalyticsValue = string | number | boolean;
export type AnalyticsParams = Record<string, AnalyticsValue | undefined>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function isAnalyticsEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host !== 'localhost' && host !== '127.0.0.1';
}

/** Guest restaurant app events. Skips local dev so production GA4 stays clean. */
export function trackEvent(name: string, params: AnalyticsParams = {}): void {
  if (!isAnalyticsEnabled() || !name) {
    return;
  }
  const payload: Record<string, AnalyticsValue> = { app_surface: 'restaurant_guest' };
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== '') {
      payload[key] = value;
    }
  });
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...payload });
}

export function trackPageView(path: string): void {
  trackEvent('page_view', {
    page_path: path + window.location.search,
    page_location: window.location.href,
    page_title: typeof document !== 'undefined' ? document.title : undefined,
  });
}
